import { createContext } from 'preact';

export const MountPointContext = createContext({
    popover: null as unknown as HTMLDivElement,
    shadowRoot: null as unknown as ShadowRoot,
});
